<template>
  <div class="take-pictures">
    <div class="content" v-for="(item,listIndex) in list" :key='listIndex'>
      <div class="title-desc">
        <span class="title-title" v-if="item&&item.title">{{item.title}}</span>
      </div>
      <div class="details-desc-div">
        <span v-if="item&&item.titleDesc" class="details-desc" v-html="item.titleDesc">{{item.titleDesc}}</span>
      </div>
      <div class="photo-content">
        <div class="img-item static" v-if="item&&item.staticSmallImg ||(item.staticSmallList&&item.staticSmallList.length >0)">
          <template v-if="item&&item.staticSmallImg">
            <el-image width="100%" lazy-load :src="item.staticSmallImg" :preview-src-list="[item.staticSmallImg]">
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
              <!--加载失败-->
              <template v-slot:error>{{$t('other.loadFail')}}</template>
            </el-image>
          </template>
          <template v-if ="item&&item.staticSmallList&&(item.staticSmallList.length) >0">
            <div v-for="(value,index) in item.staticSmallList" :key="index">
              <van-image width="100%" lazy-load :src="value" @click="showViewImage(item.swipeBigList[index])">
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
                <!--加载失败-->
                <template v-slot:error>{{$t('other.loadFail')}}</template>
              </van-image>
            </div>
          </template>
        </div>
        <div class="img-item" :class="{'add-photo':item.rejectId == 7 || item.rejectId == 12 || item.rejectId == 9}">
          <!-- 上传组件，预备一套原生的方案 -->
          <template v-if="!$isOpenInWebview">
            <h5-upload :id="item.fileId" :keyValue="item.key" :maxCount="item.maxCount?item.maxCount:1"
                       @delete="deleteImg"
                       @afterRead="afterRead"
                       :staticSmallImg_mutiOneCase="item.staticSmallImg_mutiOneCase"
                       :staticBigImg_mutiOneCase="item.staticBigImg_mutiOneCase">
            </h5-upload>
          </template>
          <template v-if="$isOpenInWebview">
            <native-upload
              v-if="item.maxCount &&item.maxCount ===1"
              @delete="deleteImg"
              :loading="loading"
              :staticImg="item.staticImg?item.staticImg:''"
              :key-value="item.key"
              :maxCount="item.maxCount"
              :preImg="item.preImg?item.preImg:''"
              :status = item.status
              :id="item.fileId"
              :sourceType="item.sourceType"
              @takePhoto="takePhoto">
            </native-upload>
            <native-muti-upload
              v-if="item.maxCount && item.maxCount>1"
              @delete="deleteImg"
              :swipeList="item.swipeList"
              :del-key-list='item.delKeyList'
              :key-value="item.key"
              :maxCount="item.maxCount?item.maxCount:1"
              :children="item.children?item.children:[]"
              :staticSmallImg_mutiOneCase="item.staticSmallImg_mutiOneCase"
              :staticBigImg_mutiOneCase="item.staticBigImg_mutiOneCase"
              @takePhoto="takePhoto">
            </native-muti-upload>
          </template>
          <div v-if="isFirst&&(!item.preImg)" class="wrapper" @click="showTipModal()"></div>
        </div>
      </div>
    </div>
    <van-image-preview v-model="show" :images="images"></van-image-preview>
    <!-- 提示弹框 -->
    <photo-overlay :show="showTip" @comfirm="confirmTip"></photo-overlay>

  </div>
</template>

<script>
const swipeImg = () => import("@/components/swipeImg.vue")
const photoOverlay = () => import("./components/photoOverlay.vue")
const h5Upload = () => import("./components/h5Upload.vue")
const nativeUpload = () => import("@/components/photo/nativeUpload.vue")
const nativeMutiUpload = () => import("@/components/photo/nativeMutiUpload.vue")

export default {
  name:'takePictures',
  components:{
    swipeImg,
    photoOverlay,
    h5Upload,
    nativeUpload,
    nativeMutiUpload
  },
  props: {
    list: {
      type: Array,
      default: ()=>[]
    },
    isFirst: {
      type:Boolean,
      default: false
    },
    loading:{
      type:Boolean,
      default: true
    },
    url:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      images:null,
      show: false,
      showTip:false,
    }
  },
  created() {
    console.log(this.list,1111)
  },
  methods:{
    afterRead(params) {
      // params.uploadCallback = (res) => {
      //   console.log('uploadCallback:')
      //   console.log(res)
      // }
      console.log(params, '-----params')
      this.$emit("afterRead",params)
    },
    deleteImg(params){
      this.$emit('delete',params)
    },
    takePhoto(params,status=0){
      const {key, photoIndex,delKey, sourceType} = params
      this.$emit('takePhoto',{key,photoIndex,status,delKey, sourceType})
    },
    // 预览图片
    showViewImage(img){
      this.show = true
      this.images = Array.isArray(img) ? img : [img]
    },
    // 拍照提示框
    showTipModal(){
      if(this.isFirst){
        this.showTip = true
      }
      // console.log(this.isFirstTakePhoto)
    },
    // 确认提示
    confirmTip(){
      this.showTip = false
      this.$emit("update:isFirst",false)
      // this.isFirstTakePhoto = false
    },
    // 删除图片
    closeImg(index,listIndex){
      // 删除图片
    },
  }
}
</script>

<style lang="less" scoped>
.take-pictures {
  display: flex;
  flex-wrap: wrap;
}
.content {
  //margin: 0 13px 0;
  color: #6E6E6E !important;

  .title-desc {
    // height: 32px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    width: 420px;
    text-align: justify;
    margin-bottom: 4px;
    .title-title {
      display: inline;
      color:#282828;
    }
    .details-desc {
      display: inline;
    }
  }

  .details-desc-div {
    max-width: 420px;
  }

  .photo-content {
    margin: 20px 10px 20px;
    display: flex;
    //justify-content: space-between;
    flex-wrap: wrap;
    .img-item {
      width: 200px;
      height: 200px;
      margin-right: 20px;
      border-radius: 4px;
      & /deep/.swiper-img {
        margin-top: 0;
        .van-swipe-item {
          height: 150px;
        }
      }
      // & /deep/ .van-image {
      //   // margin-bottom: 10px;
      //   height: 150px;
      // }
      .wrapper {
        transform: translateZ(0);
        width: 100%;
        height: 150px;
        top: 0;
        margin-top: -150px;
      }
      .close {
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 1;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #666;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        color: #fff;
      }
    }
    .add-photo{
      width:100%;
    }
    .static{
      width: 200px;
      min-height: 200px;
      & /deep/ .van-image {
        // margin-bottom: 10px;
        position: relative;
        display:block;
        margin-bottom: 5px;
        img {
          width: 100%;
          height: 100%;
          display:block;
        }
        &:before {
          // content:'Hình minh họa';
          content: 'ภาพประกอบ';
          position: absolute;
          left: 0;
          top: 0;
          width: 40px;
          font-size: 12px;
          height: 16px;
          text-align: center;
          line-height: 16px;
          color: #fff;
          background: rgba(0, 0, 0, .3);
          z-index: 1;
        }
      }
    }
  }
  /deep/ .van-image:before {
    width: 100% !important;
  }
  /deep/ .van-uploader {
    width: 200px;
    height: 200px;
  }
  /deep/ .van-uploader__input-wrapper {
    width: 200px;
    height: 200px;
  }
}
</style>
